const headerPosition = () => {
  if (window.theme.breakpoints.current === 'mobile') {
    return false;
  }

  const pre_header_height = $('.shopify-section.preheader').outerHeight() || 0;
  const header_height = $('.shopify-section.header').outerHeight() || 0;
  const window_top = $(window).scrollTop();

  if (window_top >= pre_header_height) {
    $('body').addClass('sticky-header');

    $('.mega').removeAttr('style');
  } else {
    $('body').removeClass('sticky-header');

    // Adjust the position of the subnav
    $('.mega').css('top', `${header_height + pre_header_height - window_top}px`);
  }
};

export default () => {
  $(window).on('scroll', () => {
    headerPosition();
  });

  // Stop scrolling
  $(window).on('scroll', _.debounce(() => {
    headerPosition();
  }, 100));

  // From mobile to desktop
  $(window).on('resize', _.debounce(() => {
    headerPosition();
  }, 100));
};
